'use strict';

import {initStoreAppointment} from './storelocator';

var appointmentInfo = {}; //Object to hold the selected Store,time & Date
var userPastOverlayScrollPos = [0,0];
const appointmentDefaults = {
	datelimit:30,
	storeopentime:'10:00',
	storeclosetime:'22:00',
	timeinterval:30
}

var langSelected = $('html').attr('lang');
var slickrtlAttr = (langSelected == 'ar') ? true : false;
var initTimeLoaded = false;

//Overlay Scroll Fix in IOS
function scrollLockIos(state){
    if(state === true){
        userPastOverlayScrollPos = [
            self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
            self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
        ];
        $('html').addClass('cancel-scroll noscrollios');
        $('body').addClass('cancel-scroll');

    }else{
        $('html').removeClass('cancel-scroll noscrollios');
        $('body').removeClass('cancel-scroll');
        window.scrollTo(userPastOverlayScrollPos[0], userPastOverlayScrollPos[1]);
    }
}

function initializeEvents() {
    //Store Selection Click - Navigate to Scheduler page
    $(document).on('click', '.storelist_wa', function () {
        var target = $(".storelist_wa").find('.checkbox.checked');
        target.removeClass('checked');
        $(".storelist_wa").removeClass('active-store');
        appointmentInfo = {};
        var store_info = $(this).find('.store_details_bkapp').val();
        appointmentInfo.storedetails = store_info;
        $('input[name$="storeappointment_storeAddress"]').val(store_info);
        $(this).addClass('active-store');
        if($(this).data('storeid')) {
            $('input[name$="storeappointment_storeID"]').val($(this).data('storeid'));
        }
        showTimeSlot();
        goToPageTop();
    });
    
    
    //Progress Bar click for Stage 1 and Stage 2 for back Navigation
    $(document).on("click", ".progress-bar__step", function () {
        var curEle = $(this);
        if (curEle.hasClass('active') && !curEle.hasClass('current')) {
            $(".bkappstages").addClass('hdStage');
            var slickdateEl = $('.schdate-scrollable-cta');
            if(slickdateEl.hasClass('slick-initialized')) {
                $('.schdate-scrollable-cta').slick('unslick');
            } 
            var slickTimeEl = $('.schtime-scrollable-cta');
            if(slickTimeEl.hasClass('slick-initialized')) {
                $('.schtime-scrollable-cta').slick('unslick');
            } 
            
            $(".progress-bar__step").removeClass('active current');
            if (curEle.hasClass('step-1')) {
                curEle.addClass("active current");
                $(".progress-bar__expandable").removeClass('stage-2 stage-3');
                $(".bookappointment_store").removeClass('hdStage');
            } else if (curEle.hasClass('step-2')) {
                $(".progress-bar__expandable").removeClass('stage-3').addClass('stage-2');
                curEle.addClass("active current");
                $(".step-1").addClass("active");
                $(".bookappointment_scheduler").removeClass('hdStage');
                getDatelist();
                getTimeSlots();
                ($(".dayslot-item.selected").length > 0) ? $(".dayslot-item.selected").trigger('click') : "";
                //Update the selected timeslot
                if (appointmentInfo.appointmenttime !== "undefined" && appointmentInfo.appointmenttime !== "null") {
                    ($(".timeslot-item.slotdisabled").length != $(".timeslot-item").length) ? $(".timeslot-item[data-slot='" + appointmentInfo.appointmenttime + "']").addClass('selected') : "";
                }
            }
        }
    });

    //Day Selection of the Scheduler
    $(document).on("click", ".dayslot-item", function () {
        $(".dayslot-item,.timeslot-item").removeClass('selected');
        $(this).addClass('selected');
        var dateSelected = $(this).find(".sch_date").val();
        appointmentInfo.appointmentdate = dateSelected;
        appointmentInfo.dateheader = $(this).attr('id');
        var date = getFormattedDate(dateSelected);
        $('input[name$="storeappointment_date"]').val(date);
        if (datesAreOnSameDay(new Date(dateSelected), new Date())) {
            checkTimeSlotRange();
        } else {
            $(".timeslot-item").removeClass('slotdisabled');
            $(".schtime-scrollable-cta").slick("slickGoTo", 0);
        }

    });

    //TimeSlot Selection - navigate to appointment form
    $(document).on("click", ".timeslot-item", function () {
        if (!$(this).hasClass('slotdisabled')) {
            $(".timeslot-item").removeClass('selected');
            $(this).addClass('selected');
            var selected_timeslot = $(this).attr('data-slot');
            appointmentInfo.appointmenttime = selected_timeslot;
            $('input[name$="storeappointment_time"]').val(selected_timeslot);
            checkIfSlotExpired();
        }
    });

    //User Submit Appointment form
    $(document).on("click", "#book_appointment_btn", function () {
        appointmentInfo = {}; // Clear on  Submission	
        $(".bkappstages,.bookappointment_stage_ct").addClass('hdStage');
        $(".bookappointment_completed_ct").removeClass('hdStage');
    });

    //Slot Modal Close Action
    $(document).on("click", ".slot_expiry_btn", function () {
        $(".slot_expiry_modal").addClass('modal-hide');
        scrollLockIos(false);
        $("body").removeClass('cancel-scroll');
    });
    
    initStoreAppointment();
    
    $(document).ready(function () {
        var limitInterval = 0;
        var timeSlotInterval = setInterval(function(){
            var timeEl = activateTimeSlot();
            if(timeEl) {
                initTimeLoaded = true;
            }
            if(timeEl || limitInterval > 5){
                clearInterval(timeSlotInterval);
            }
            limitInterval += 1;
        }, 100); 
    });
}

window.addEventListener('load', function () {
     if(!initTimeLoaded) {
        activateTimeSlot();
     }
});

function activateTimeSlot()
{
    if($('.step-2').hasClass('current active') && $('.active-store').length > 0) {
        $('.active-store').trigger('click');
        return true;
    }
}

function goToPageTop()
{
    var scrollTop = $('.bookappointment_Info').offset().top-40;
    $('html, body').animate({
        scrollTop: scrollTop
    }, 1000);
}

function showTimeSlot()
{
    $('.active-store').find('.checkbox').addClass('checked');
    $(".bookappointment_store").addClass('hdStage');
    $(".bookappointment_scheduler").removeClass('hdStage');
    $(".progress-bar__step").removeClass('current');
    $(".progress-bar__step.step-2").addClass('active current');
    $(".progress-bar__expandable").addClass('stage-2');
    getDatelist();
    getTimeSlots();
}
    
    
//Generate Day Scheduler
var getDatelist =  function() {
	var tmp = ``;
	const weekdays = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
	const monthName = ["January", "February", "March", "April", "May", "June",
	"July", "August", "September", "October", "November", "December"];
	var startDate = new Date();
	for (let i = 0; i < appointmentDefaults.datelimit; i++) {
		var d = startDate.addDays(i);
		tmp += `<div class="content-items dayslot-item" id="sch-date-header-` + i + `">
				<div class="sch-day">` + weekdays[d.getDay()] + `</div>
				<div class="sch-date">` + d.getDate() + `</div>
				<div class="sch-month">` + monthName[d.getMonth()] + `</div>
				<input type="hidden" class="sch_date" value="` + d + `" /></div>`;
	}
	$(".schdate-scrollable-cta").html(tmp);
	$(".schdate-scrollable-cta").slick({
		"slidesToShow":7, 
		"arrows": true, 
		"slidesToScroll": 7, 
		"infinite": false ,
		"variableWidth":false ,
		"rtl":slickrtlAttr,
		"responsive": [{"breakpoint": 1025, "settings": {"slidesToShow": 3, "slidesToScroll": 3,"arrows": true } }, 
						{"breakpoint": 768, "settings": {"slidesToShow": 3.5, "slidesToScroll": 3, "arrows": false, "dots": false ,"variableWidth": true} } ]
	  });
	// Reinitialize the slick selected element on progress bar back  navigation
	if(appointmentInfo.dateheader !== "undefined" && appointmentInfo.dateheader !== "null"){
		$("#"+appointmentInfo.dateheader).addClass('selected');
	}
}

//Check if the user selected timeslot expired due to inactivity and show modal to update the selection
var checkIfSlotExpired = function(){
	var dateSelected = $(".dayslot-item.selected").find(".sch_date").val();
	if(datesAreOnSameDay(new Date(dateSelected), new Date())){
        var targetSlot = $(".timeslot-item.selected");
		var slot = targetSlot.attr('data-slot').split(' - ');
		if(checkCurrentTimeSlot(slot[0],slot[1]) == true){
			$(".slot_expiry_modal").removeClass('modal-hide');
            scrollLockIos(true);
            targetSlot.addClass('current slotdisabled').removeClass('selected');
		}else{
			navigateToAppointmentForm();
		}
	}else{
		navigateToAppointmentForm();
	}
}

function navigateToAppointmentForm(){
	$(".bkappstages").addClass('hdStage');
	$(".bookappointment_usr_form").removeClass('hdStage');
	$(".progress-bar__step").removeClass('current');
	$(".progress-bar__step.step-3").addClass('active current');
	$(".progress-bar__expandable").addClass('stage-3').removeClass('stage-2');
	goToPageTop();
}

function parseTime(s) {
	var c = s.split(':');
	return parseInt(c[0]) * 60 + parseInt(c[1]);
}
  
function convertHours(mins){
	var hour = Math.floor(mins/60);
	var mins = mins%60;
	var converted = pad(hour, 2)+':'+pad(mins, 2);
	return converted;
}
  
function pad (str, max) {
	str = str.toString();
	return str.length < max ? pad("0" + str, max) : str;
}

//Calculate timeslots
function calculate_time_slot(start_time, end_time, interval = "30"){
	var i, formatted_time;
	var time_slots = new Array();
	var  range_arr = new Array();
	for(var i=start_time; i<=end_time; i = i+interval){
		formatted_time = convertHours(i);
	    time_slots.push(formatted_time);
	}
	var slotlength = time_slots.length;
	for(var i=0;i<slotlength;i++){
		if(i != slotlength){
			range_arr.push(time_slots[i] +' - ' + time_slots[i+1]);
		}
	}
	range_arr.pop();
	return range_arr;
}

//Check if the user selected is current day
const datesAreOnSameDay = (first, second) =>
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();

//Generate Timeslots
var getTimeSlots =  function(){
	  var tmp = ``;
	  var timeslots = calculate_time_slot(parseTime(appointmentDefaults.storeopentime), parseTime(appointmentDefaults.storeclosetime), appointmentDefaults.timeinterval);
	  $.each(timeslots,function(idx,value){
		tmp += `<div class="content-items timeslot-item slotdisabled" data-slot="` + value + `">` + value + `</div>`;
	  });
	  $(".schtime-scrollable-cta").html(tmp);
	  $(".schtime-scrollable-cta").slick({
			"slidesToShow":7, 
			"arrows": true, 
			"slidesToScroll": 7, 
			"infinite": false ,
			"variableWidth":false ,
			"rtl":slickrtlAttr,
			"responsive": [{"breakpoint": 1025, "settings": {"slidesToShow": 4, "slidesToScroll": 4,"arrows": true } }, 
							{"breakpoint": 768, "settings": {"slidesToShow": 3.5, "slidesToScroll": 3, "arrows": false, "dots": false ,"variableWidth": true} } ]
	  });

}

//Style the current timeslot
function checkTimeSlotRange() {
    const dt = new Date();
    const storeOpenHr = appointmentDefaults.storeopentime.split(":")[0];
    if(dt.getHours() >= storeOpenHr){
        $(".timeslot-item").addClass('slotdisabled');
        $(".timeslot-item").each(function(key,value){
            var curItem = $(this);
            var slot = curItem.attr('data-slot').split(' - ');
            if(checkCurrentTimeSlot(slot[0],slot[1]) == true){
                curItem.addClass('current');
                $(".schtime-scrollable-cta").slick("slickGoTo", key);
            }
        });
        $(".timeslot-item.current").nextAll().removeClass('slotdisabled');
    }else{
        $(".timeslot-item").removeClass('slotdisabled');
    }
}

//Get the current timeslot marked
var checkCurrentTimeSlot = function(startTime,endTime){
	var dt = new Date(Date.now());
	var now = dt.getHours() + ":" + dt.getMinutes();

	var selectedTimeSeconds = now.substring(0,5) + ':00';
	var startTimeSeconds = startTime.substring(0,5) + ':00';
	var endTimeSeconds = endTime.substring(0,5) + ':00';

	var selectedTimeSecondsParsed = hmsToSecondsOnly(selectedTimeSeconds)
	var startTimeSecondsParsed = hmsToSecondsOnly(startTimeSeconds)
	var endTimeSecondssParsed = hmsToSecondsOnly(endTimeSeconds)
	if (selectedTimeSecondsParsed >= startTimeSecondsParsed && 
		selectedTimeSecondsParsed <= endTimeSecondssParsed) {
		return true;
	}
}

const hmsToSecondsOnly = function(str) {
	var p = str.split(':'),s = 0,m = 1;
	while (p.length > 0) {
		s += m * parseInt(p.pop(), 10);
		m *= 60;
	}
	return s;
}

Date.prototype.addDays = function(days) {
	var date = new Date(this.valueOf());
	date.setDate(date.getDate() + days);
	return date;
}

function getFormattedDate(date)
{
    try {
        var dt = new Date(date);
        var month = '' + (dt.getMonth() + 1),day = '' + dt.getDate(),year = dt.getFullYear();
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
        return [year, month, day].join('-');
    } catch (e) {
        return '';
    }
}

exports.init = function () {
    initializeEvents();
};




// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/bookappointment.js